import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';


import DeleteModal from './DeleteModal';
import { Grid } from '@mui/material';
import PaginationSection from './PaginationSection';

const defaultTableStyle = {
  headerCell: {
    color: '#A1A1A1', 
    borderBottom: '0', 
    padding: '0.5rem 0.5rem',
    fontSize:'0.8125rem',
    width:'20%'
  },
  headerRow:{
    borderBottom:'1px solid #A1A1A1'
  },
  bodyCell:{
    padding: '1rem 0.5rem',
    width: 'calc( 100% / 3)',
    borderBottom: '1px solid #F8F8F8',
    maxWidth: 0
  },
  preventOverflow: {
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
  },
  twoLinesOverflow: {
    fontSize: '0.875rem', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden'
  }
};

const missingColor = '#e31212ff'


export default function DataGrid({
  tableData = [],
  onEdit,
  onDelete,
  onVariants,
  page, 
  rowsPerPage,
  totalPages,
  onPageChange,
  onRowsPerPageChange,
  isLoading,
  characteristicCategories,
  tableStyle=defaultTableStyle,
  actions,
  showPagination=true,
  nowrap=false
}) {

  const [rows, setRows] = React.useState([]);
  
  const [openModal, setOpenModal] = React.useState(false);
  const [deleteTitle, setDeleteTitle] = React.useState('');
  const [elementToDelete, setElementToDelete] = React.useState('');


  React.useEffect( () => {
    setRows(tableData);
  },[tableData]);


  const onDeleteModal = (item) => {
    setElementToDelete(item);
    setDeleteTitle(`¿Deseas borrar la característica ${item.characteristicName}?`);
    setOpenModal(true);
  };

  const onConfirmed = () => {
    onDelete(elementToDelete);
    onCloseModal();
    
  };

  const onCloseModal = () =>{
    setOpenModal(false);
    setElementToDelete(null);
  };

  return (
    <>
      <Box sx={{ p: 2 }} component={Paper}>
        <Grid container spacing={2}>
          {rows.length > 0 ? (
            rows.map((row, index) => (
              <Grid item xs={12} {...(!nowrap && { md: 6 })} key={index}>
                <Paper sx={{ p: 2, boxShadow: 2 }} >
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={9} sm={10} md={10} lg={11} xl={10}>
                      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2 }}>
                        {
                          characteristicCategories.find(item =>
                            item.value === (
                              typeof row.characteristicCategory === 'object'
                                ? row.characteristicCategory?.value
                                : row.characteristicCategory
                            )
                          )?.iconComponent ?? (
                            <Box
                              sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: 1,
                              }}
                            >
                              <ErrorOutlineIcon sx={{ fontSize: {lg:'1.5rem'}, color: missingColor}}/>
                            </Box>
                          )
                        }
                        <Typography
                          sx={{
                            color: "#2C2C2C",
                            fontWeight: "600",
                            ...tableStyle.twoLinesOverflow,
                          }}
                        >
                          {row.characteristicName}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={3} sm={2} md={2} lg={1} xl={2}>
                      {actions({
                        onEdit: onEdit,
                        onDelete, onDeleteModal,
                        onVariants: onVariants,
                        rowItem: row
                      })}
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Paper sx={{ p: 2, textAlign: "center", color: "#999" }}>
                SIN DATOS
              </Paper>
            </Grid>
          )}
        </Grid>
      </Box>
      {showPagination && (
        <PaginationSection 
        rows={rows}
        page={page}
        rowsPerPage={rowsPerPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        isLoading={isLoading}
      />
      )}
      <DeleteModal title={deleteTitle} confirmButtonText={'Eliminar característica'} onConfirmed={onConfirmed} openModal={openModal} onCloseModal={onCloseModal}/>
    </>
  );
}
